import { RootState } from "../../../store";
import {
  cloudChiprApi,
  ResourceType,
} from "../../../../services/cloudchipr.api";
import { resourceViewIsWithoutFiltersSelector } from "../current-account/resources/resourceViewIsWithoutFiltersSelector";
import { getResourceTypeDataWithoutFiltersFixedCacheKey } from "../../thunks/filters-get/getCurrentAccountResourceTypeWithoutFiltersDataThunk";
import { filterTemplatesEnabledSelector } from "../current-account/resources/filterTemplatesEnabledSelector";

export const resourceTypeDataLoadingSelector = (
  state: RootState,
  resourceType: ResourceType,
) => {
  const withoutFilters = resourceViewIsWithoutFiltersSelector(
    state,
    resourceType,
  );
  const filterTemplatesEnabled = filterTemplatesEnabledSelector(state);

  const fixedCacheKey =
    withoutFilters || !filterTemplatesEnabled
      ? getResourceTypeDataWithoutFiltersFixedCacheKey(resourceType)
      : resourceType;

  return cloudChiprApi.endpoints.postUsersMeV2OrganisationsCurrentByTypeResources.select(
    fixedCacheKey,
  )(state)?.isLoading;
};
